import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineExtraSmallButton, PrimaryButton } from "../../../../Constant";
import { EXTRA_SMALL_OUTLINE_BUTTONS, EXTRA_SMALL_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const OutlineExtraSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineExtraSmallButton} span={EXTRA_SMALL_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="xs" outline color="primary" id="Tooltip-68">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-68" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-outline-primary btn-xs</ToolTip>
          {EXTRA_SMALL_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonButton key={index} item={data} outline={true} size="xs"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default OutlineExtraSmallButtons;
